import AboutTests from './AboutTests'

export default AboutTests
